<template>
 <div class="finance-reports-accounts">
    <div class="finance-reports-accounts__filters d-flex my-3">
        <datepicker
          id="selectedDate"
          v-model="selectedDate"
          :startDate="minDateForSelect"
          :endDate="maxDateForSelect"
          class="ml-2"
        >
        </datepicker>
        <button @click="loadAccounts" class="btn btn-primary mx-3" :disabled="!selectedDate">Применить</button>
    </div>
    <table class="table py-3 w-75">
      <thead>
        <tr>
          <th v-for="item in tableHeaderItems" :key="item.name" :style="{'width': item.width * 100 / tableHeaderItems.map(x=>x.width).reduce((a, b) => a + b) + '%'}">
            <div class="table-th">{{ item.viewName }}</div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="account in accounts" :key="account.id">
          <td>
            <div class="td-content" :title="account.number">{{account.number}}</div>
          </td>
          <td>
            <div class="td-content" :title="account.name">{{account.name}}</div>
          </td>
          <td>
            <div class="td-content td-content-lg" :title="account.enabled ? 'активный': 'не активный'">
              <div class="finance-settigs__property-pill" v-if="account.enabled">
                <span>активный</span>
              </div>
              <div class="finance-settigs__property-pill finance-settigs__property-pill--disabled"  v-if="!account.enabled">
                <span>не активный</span>
              </div>
            </div>
          </td>
          <td>
            <div class="td-content" :title="account.balance">{{account.balance}}</div>
          </td>
        </tr>
      </tbody>
    </table>
 </div>
</template>

<script>
import api from '../../../../api'
import datepicker from '../../../../components/datepicker.vue'
import { sortBy } from 'lodash'
import moment from 'moment'

const formatNumber = (num) => {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
}

const today = new Date()
const isDemo = location.host.indexOf('demo') >= 0
const demoFirstDate = new Date(2021, 0, 1)
const maxDate = new Date(new Date().setDate(today.getDate() + 1))
const minDate = new Date(0)

export default {
  name: 'FinanceReportsAccounts',
  data () {
    return {
      accounts: [],
      tableHeaderItems: this.getTableHeader(),
      minDateForSelect: minDate,
      maxDateForSelect: maxDate,
      selectedDate: isDemo ? demoFirstDate : today
    }
  },
  components: {
    datepicker
  },
  methods: {
    getTableHeader () {
      return [
        {
          name: 'number',
          viewName: 'Номер',
          width: 150,
          isVisible: true
        },
        {
          name: 'name',
          viewName: 'Название',
          width: 175,
          isVisible: true
        },
        {
          name: 'enabled',
          viewName: 'Статус',
          width: 200,
          isVisible: true
        },
        {
          name: 'balance',
          viewName: 'Баланс',
          width: 175,
          isVisible: true
        }
      ]
    },
    loadAccounts () {
      const date = moment(this.selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD')
      api.get.reportFinanceAccount(date)
        .then((resp) => {
          this.accounts = sortBy(resp.data.data.finance_accounts.map(x => { return { ...x, balance: formatNumber(+x.balance) } }), 'name')
        })
        .catch(() => {
          this.$notify({
            message: 'Произошла ошибка',
            type: 'danger'
          })
        })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$eventBus.$emit('pageHeaderChange', 'настройки финансов')
    })
  }
}
</script>

<style lang="scss">
.finance-settigs {
  &__property-pill {
    display: inline-block;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    text-align: center;
    width: 84px;
    height: 17px;
    color: #fff;
    background-color: #28bd8b;
    border-radius: 4px;

    &--disabled {
      background-color: #f34d65;
    }
  }
}
</style>
